"use client";

import Script from "next/script";
import { useEffect } from "react";

declare global {
  interface Window {
    fbq?: (
      action: string,
      event: string,
      params?: Record<string, unknown>
    ) => void;
    _fbq?: typeof window.fbq;
  }
}

export const MetaPixel = () => {
  useEffect(() => {
    // Vérification en développement
    if (process.env.NODE_ENV === "development") {
      const checkPixel = setInterval(() => {
        if (window.fbq) {
          console.log("✅ Meta Pixel chargé avec succès");
          console.log("Pixel ID: 1930437737583075");
          console.log("Pour vérifier: window.fbq('getState')");
          clearInterval(checkPixel);
        }
      }, 100);

      // Nettoyer après 5 secondes
      setTimeout(() => {
        clearInterval(checkPixel);
      }, 5000);
    }
  }, []);

  return (
    <>
      {/* Meta Pixel Code */}
      <Script
        id="meta-pixel"
        strategy="afterInteractive"
        onLoad={() => {
          if (process.env.NODE_ENV === "development") {
            console.log("📊 Meta Pixel script chargé");
          }
        }}
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1930437737583075');
            fbq('track', 'PageView');
          `,
        }}
      />
      {/* Noscript fallback */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src="https://www.facebook.com/tr?id=1930437737583075&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>
    </>
  );
};
